module.exports = __webpack_public_path__ + "img/kate-600x600.752396a5.png";